import { get, writable } from 'svelte/store'
import { timelapseRunning } from './store'

export function commandStore(initialValue, actions) {
	const { subscribe, set, update } = writable(initialValue);
    let currentIndex = -1;

    function execute(command, args) {
        const action = actions[command]
        action.execute(args);
        didExecute(action, args, command)
    }
    
	// add a command to the stack which was executed elsewhere
	function didExecute(action, args, name) {
        currentIndex++;
        update((commands) => {
            commands.splice(currentIndex, commands.length, [action, args, name])
            return commands
        })
	}

	// undo one command, if possible
	// could potentially return a boolean that indicates if an undo occurred
	function undo() {
        update((commands) => {
            if (canUndo([...commands])) {
                commands[currentIndex][0].undo(commands[currentIndex][1]);
                currentIndex--;
            }
            return commands
        })
    }

    // whether on not the current stack supports undo
	function canUndo(commands){
		return !!commands[currentIndex];
	}

	// redo one command, if possible
	function redo() {
        update((commands) => {
            if (canRedo([...commands])) {
                commands[currentIndex + 1][0].redo(commands[currentIndex + 1][1]);
                currentIndex++;
            }
            return commands;
        })
	}

	// whether on not the current stack supports redo
	function canRedo(commands){
		return !!commands[currentIndex + 1];
	}

	// undo all commands
	function cancel() {
		while (currentIndex >= 0) {
			undo();
		}
	}

    function stopTimelapse() {
        timelapseRunning.set(false);
        update((commands) => {
            while (canRedo(commands)) {
                redo();
            }
            return commands
        });
    }
    
    function timelapse(speed) {
        timelapseRunning.set(true);
        update((commands) => {
            cancel();
            let i = 0;
            const ref = setInterval(() => {
                redo();
                i++;
                if (i === commands.length || get(timelapseRunning) === false) {
                    clearInterval(ref);
                    timelapseRunning.set(false);
                    return
                }
            }, speed);
            return commands
        });
    }
    

	return {
		subscribe,
        execute: (command, args) => execute(command, args),
		undo,
        redo,
        cancel,
        timelapse: (speed) => timelapse(speed),
        stopTimelapse
	}

}